export default {
  type: 'Life',
  sections: [
    { id: 'life1', title: 'What is Life Insurance' },
    { id: 'htgbr', title: 'How to Get The Best Rate' },
    { id: 'coverage', title: 'Types & Coverage Options' },
    { id: 'life2', title: 'Life Insurance Use Cases' },
    { id: 'life3', title: 'Price Impacting Factors' }
  ],
  introData: {
    title: 'Life Insurance Guide',
    paragraphs: [
      "To describe life insurance simply, it is a contract that will pay money to named 'beneficiaries' on your death. Life Insurance can be used in many different and beneficial ways, so it can sometimes be complicated to understand the different types.",
      "At Insurance Express, we help you navigate the complexities of life insurance to find a policy that provides the right protection for your loved ones and fits your financial goals.",
      "Our experienced agents work with you to identify your specific needs and match you with the best coverage options at competitive rates."
    ]
  },
  typesList: [
    'Term Life Insurance',
    'Whole Life Insurance',
    'Variable Life Insurance',
    'Universal Life Insurance',
    'Group Life Insurance'
  ],
  typesListTitle: 'Different Types of Life Insurance',
  bestRateTips: [
    "Start early: Life insurance rates increase as you age, so it's generally less expensive to buy when you're younger and healthier.",
    "Compare quotes from multiple providers: Different companies may offer significantly different rates for the same coverage.",
    "Choose the right amount of coverage: Buying more coverage than you need can lead to unnecessarily high premiums.",
    "Consider your health: Staying healthy through diet, exercise, and avoiding tobacco can help you qualify for better rates.",
    "Bundle policies: Some insurance companies offer discounts if you have multiple types of insurance with them."
  ],
  briefGuide: 'Life insurance provides financial security for your loved ones in the event of your death. It can help cover funeral expenses, replace lost income, pay off debts, and provide for your family\'s future needs.',
  coverageItems: [
    'Term Life: Provides coverage for a specific period (10, 20, 30 years)',
    'Whole Life: Lifetime coverage with a cash value component',
    'Universal Life: Flexible premium payments and death benefits',
    'Variable Life: Investment options within your policy',
    'Final Expense: Smaller policies designed to cover funeral costs'
  ],
  additionalInfo: {
    overview: 'Looking at the different types of life insurance, you may wonder, "I think I should get life insurance, but what kind do I get?" Everyone\'s situation is different, but understanding the different ways people use life insurance policies can help see what might be right for you.',
    sections: [
      {
        title: 'Replacing Lost Income',
        paragraphs: [
          "If you are the head of household, or provide the majority of the financial support in your family, you may be looking into life insurance so that you will be protected in the event of your death.",
          "All three types of life insurance will provide money to help replace lost income for your loved ones in the event of your death."
        ]
      },
      {
        title: 'College Planning',
        paragraphs: [
          "A whole life policy or variable life policy can be used as a way for you to save for your child's college expenses.",
          "One of the features of a whole life policy or a variable life policy is the ability to actually save money during the term of the policy.",
          "They both can accrue value during their term and you can take a loan out on the value of your policy to pay for your child's college expenses or, through the limits of the death benefit of the policy, college debt can be paid off at the time of your death."
        ]
      },
      {
        title: 'Building Cash Value',
        paragraphs: [
          "Many people actually use life insurance as a financial tool more so than insurance policy that protects you financially in the event of your death, this is due to the \"Cash Value\" aspect of whole life or variable life insurance.",
          "During the term of your policy, the cash value of the policy value will grow. You have the ability to take out a loan against the value of your life insurance policy, similar to a \"home equity line of credit.\" Life insurance policies come with many tax advantages and is seen as an investment."
        ]
      }
    ]
  },
  pricingFactors: {
    title: "Main Price Impacting Factors for Life Insurance",
    description: "When comparing rates and coverages for life insurance, it is important to keep in mind data points that Insurance Companies find most important when evaluating your rate.",
    factors: [
      {
        title: "Multi-Policy Discount",
        description: "It goes without saying, Insurance Companies like when you purchase more than one policy with them. Consider this when you are getting one policy, they may give a deeper discount by adding another.",
        imageUrl: "/images/productPageImages/multi.png"
      },
      {
        title: "Smoking Status",
        description: "Smoking has been known to cause early death. This is one of the main and most impactful data points for Life Insurance companies to use when determining your life insurance rates.",
        imageUrl: "/images/productPageImages/multi.png"
      },
      {
        title: "Marital Status",
        description: "Single vs. Married- Your marital status can surprisingly affect your insurance rates! There is a more broad category for the interpretation of how this affects your risk rating but it is generally understood that if you are married this produces better rates on your life insurance.",
        imageUrl: "/images/productPageImages/marital.png"
      },
      {
        title: "Age",
        description: "It goes without saying, life insurance is measuring your risk of death. Plain and simple, the older you are, the more you are naturally closer to death. The older you are, the higher your rates will be, the younger you are, the lower your rates will be. Start your life insurance while you are young!",
        imageUrl: "/images/productPageImages/age.png"
      },
      {
        title: "Health Status",
        description: "Your overall health plays a significant role in determining your life insurance rates. Many insurers require a medical exam as part of the application process, and conditions like high blood pressure, diabetes, or obesity can lead to higher premiums.",
        imageUrl: "@/assets/images/productPageImages/health.png"
      }
    ]
  },
  relatedProducts: [
    {
      title: "Home Insurance",
      imageUrl: "@/assets/images/product-type-icons/homeInsurance.svg",
      link: "/products/homeinsurance"
    },
    {
      title: "Auto Insurance",
      imageUrl: "@/assets/images/product-type-icons/autoInsurance.svg",
      link: "/products/autoinsurance"
    },
    {
      title: "Medicare Supplement",
      imageUrl: "@/assets/images/product-type-icons/lifeInsurance.svg",
      link: "/products/medicare"
    }
  ],
  ctaText: "(Auto, Home, Medicare, etc.)"
}; 